<!-- ContentRenderer.vue -->
<template>
  <section
    v-for="node in nodes"
    :id="node.numId"
    :key="node.id"
    :class="['content-section', `level-${node.level}`]"
    v-intersect="handleIntersect(node.id)"
  >
    <component :is="`h${Math.min(node.level + 1, 4)}`" class="content-heading">
      <span class="num-id">{{ node.numId }}</span>
      {{ node.name }}
    </component>

    <div v-if="node.content" class="content-body">
      <MarkdownRenderer
        :content="node.content"
        @link-click="handleInternalLink"
      />
      <span class="num-id">{{ node.content }}</span>
    </div>

    <!-- 改进后的图片展示 -->
    <div v-if="node.image" class="image-gallery-wrapper">
      <el-image
        v-for="(img, index) in parseImages(node.image)"
        :key="index"
        :src="img.src"
        :preview-src-list="previewList(node)"
        fit="cover"
        class="content-image"
        hide-on-click-modal
      >
        <template #error>
          <div class="image-error">图片加载失败</div>
        </template>
      </el-image>
    </div>

    <ContentRenderer v-if="node.children.length > 0" :nodes="node.children" />
  </section>
</template>

<script setup lang="ts">
import { defineProps } from "vue";
import { useStandardStore } from "@/stores/standard";
import ContentRenderer from "@/content/ContentRenderer.vue";

// Define the props for the component
const props = defineProps<{
  nodes: Array<{
    id: number;
    numId: string;
    level: number;
    name?: string;
    content?: string;
    image?: string;
    children: Array<any>;
  }>;
}>();

// 改进的图片解析方法
const parseImages = (images?: string) => {
  if (!images) return [];
  return images
    .split(",")
    .filter((url) => url.trim())
    .map((url) => ({
      src: buildFullUrl(url.trim()),
      thumbnail: generateThumbnailUrl(url.trim()),
    }));
};
const handleInternalLink = (url: string) => {
  const hash = new URL(url).hash.slice(1);
  const target = document.getElementById(hash);
  target?.scrollIntoView({ behavior: "smooth" });
};
// 生成预览列表
const previewList = (node: any) => {
  return parseImages(node.image).map((img) => img.src);
};

// 构建完整URL
const buildFullUrl = (url: string) => {
  if (!url) return "";
  if (url.startsWith("http")) return url;
  return `http://8.138.108.78:8080/${url}`;
};

// 生成缩略图URL
const generateThumbnailUrl = (url: string) => {
  return `${buildFullUrl(url)}?x-oss-process=image/resize,w_200/quality,q_70`;
};
const handleIntersect = (id: number) => ({
  handler: (isVisible: boolean) => {
    if (isVisible) useStandardStore().setActiveNode(id);
  },
  options: { threshold: 0.5 },
});
</script>

<style>
.content-heading {
  background: white;
  padding: 12px 0;
  z-index: 10;

  .num-id {
    color: #2b542c;
    margin-right: 8px;
  }
}

.content-body {
  margin: 16px 0;
  padding-left: calc(var(--level) * 20px);
}
/* 新增图片尺寸控制 */
.image-gallery-wrapper {
  margin: 16px 0;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 12px;
}

/* 基础图片样式 */
.content-image {
  width: 100%;
  height: auto;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  aspect-ratio: 4/3; /* 保持4:3宽高比 */
  object-fit: cover;
}
</style>
